import React from 'react';
import styles from './TextEffectsGlitch.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';
import cx from 'clsx';
import { usePatterns } from '../../TextEffectsShared/viewer/patterns/usePatterns';
import { Patterns } from '../../TextEffectsShared/viewer/patterns/Patterns';

export type TextEffectsGlitchProps = TextEffectsSharedProps;

const TextEffectsGlitch: React.FC<TextEffectsSharedProps> = props => {
  const { content, arePatternsDisabled } = usePatterns(props);

  return (
    <TextEffectsShared
      {...props}
      arePatternsDisabled={arePatternsDisabled}
      tagProps={{
        animated: true,
        'data-testid': TestIds.viewer.container,
      }}
    >
      <Patterns
        content={content}
        arePatternsDisabled={arePatternsDisabled}
        patternScope={props.patternScope}
        unitProps={data => ({
          className: styles.container,
          'data-text': data,
          disabledPattern: arePatternsDisabled,
        })}
        unitPredicate={data => (
          <span
            data-testid={TestIds.viewer.text}
            className={cx(styles.text, styles.block)}
          >
            {data}
          </span>
        )}
      />
    </TextEffectsShared>
  );
};

export default TextEffectsGlitch;
